import { render } from "./SearchProductsByFamily.vue?vue&type=template&id=2bea3da4"
import script from "./SearchProductsByFamily.vue.ts?vue&type=script&lang=ts"
export * from "./SearchProductsByFamily.vue.ts?vue&type=script&lang=ts"
script.render = render

export default script